import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImgRequestService {

  constructor() { }

  public getGuildMarkHTML(guildId: number, server: string): string {
    if(guildId <= 0)
      return "<img src='https://wydmisc.raidhut.com.br/guild/guild0.gif'>";
    else if(server == "odin")
      return "<img src='https://wydmisc.raidhut.com.br/guild/img_guilds/b01" + ("000000" + guildId).slice(-6) + ".bmp' onerror='this.onerror=null;this.src=&quot;https://wydmisc.raidhut.com.br/guild/guild0.gif&quot;'>";
    else
      return "<img src='https://wydmisc.raidhut.com.br/guild/img_guilds/" + server + "/w01" + ('00'+(guildId>>12)).slice(-2)+('0000'+(guildId&0xFFF)).slice(-4) + ".bmp' onerror='this.onerror=null;this.src=&quot;https://wydmisc.raidhut.com.br/guild/guild0.gif&quot;'>";
  }

  public getKingdomHTML(kingdom: string): string {
    if(kingdom != "red" && kingdom != "blue")
      kingdom = "white";
    return "<img src='https://wydmisc.raidhut.com.br/guild/" + kingdom + ".gif' onerror='this.onerror=null;this.src=&quot;https://wydmisc.raidhut.com.br/guild/white.gif&quot;'>";
  }
}
